<template>
    <div class="flex-grow-1-scroll h- no-gutters" ref="container">
        <div class='position-relative d-flex flex-column'>
            <loading ref="loading"></loading>

            <header class="p-2 header__dashboard--top" style="z-index: 100;">
                <h1 class="h2" style="">System Tests</h1>
            </header>
            <div>
                core: <datetime2 type='core' v-model='start_datetime' />
                <!-- datetime-local: <datetime2 type='datetime-local' v-model='start_datetime' />
                datetime: <datetime2 type='datetime' v-model='start_datetime' /> -->
                bootstrap: <datetime2 type='bootstrap' v-model='start_datetime' />
            </div>
            <div class='message-actions'>
                <div style="padding: 20px; width: 500px">
                    <h3>Signpost Test</h3>
                    {{ signpost_data }}
                </div>
                <div style="padding: 20px; max-width: 1000px">
                    <h3>Nav bar component test</h3>


                    <div class="form-inline d-flex justify-content-between message-tabs"><div class="form-check radio-tab mr-auto"><!----> <input name="messageTo" id="internal-checkbox" type="radio" class="form-check-input" value="true"> <label for="internal-checkbox" name="messageTo" class="form-check-label message-internal">Internal Note</label> <button class="btn btn-round btn-primary">Video Call</button></div> <div class="priority-flags"><div id="flag" class="m-2 btn-group b-dropdown dropdown dropup routine"><!----><button id="flag__BV_toggle_" aria-haspopup="true" aria-expanded="false" type="button" class="btn btn-light btn-sm dropdown-toggle"></button><div role="menu" aria-labelledby="flag__BV_toggle_" class="dropdown-menu dropdown-menu-right"><button role="menuitem" type="button" class="dropdown-item"><span class="flag flag-emergency"></span> Emergency</button> <button role="menuitem" type="button" class="dropdown-item"><span class="flag flag-urgent"></span> Urgent</button> <button role="menuitem" type="button" class="dropdown-item"><span class="flag flag-visit"></span> Visit Request</button> <button role="menuitem" type="button" class="dropdown-item"><span class="flag flag-routine"></span> Routine</button> <button role="menuitem" type="button" class="dropdown-item"><span class="flag flag-lower"></span> Lower</button></div></div></div></div>

                    <div class="d-flex flex-row flex-wrap justify-content-between align-items-center">
                        <button class="mb-1 btn btn-outline-primary btn-round align-self-end btn-sm ml-1 mr-1">Await reply</button>
                        <button class="mb-1 btn btn-outline-primary btn-round mr-1 align-self-end btn-sm">Complete</button>
                        <div>
                            <div class="btn-group">
                                <span title="" class="icon-preset-message" data-original-title="Preset Messages"></span>
                            </div>
                            <div>
                                <div id="__BVID__78___BV_modal_outer_">
                                    <div id="__BVID__78" role="dialog" aria-hidden="true" class="modal fade" style="display: none;">
                                        <div class="modal-dialog modal-lg modal-dialog-centered">
                                            <div tabindex="-1" role="document" aria-labelledby="__BVID__78___BV_modal_header_" aria-describedby="__BVID__78___BV_modal_body_" class="modal-content">
                                                <header id="__BVID__78___BV_modal_header_" class="modal-header">
                                                    <h5 class="modal-title">Choose a preset message</h5>
                                                    <button type="button" aria-label="Close" class="close">×</button>
                                                </header>
                                                <div id="__BVID__78___BV_modal_body_" class="modal-body">
                                                    <p class="text-center">Loading preset messages ...</p>
                                                </div>
                                                <footer id="__BVID__78___BV_modal_footer_" class="modal-footer">
                                                <div class="w-100">
                                                    <button type="button" class="btn float-right btn-primary btn-sm">Close</button>
                                                </div>
                                                </footer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-1 ml-auto mr-2 form-inline">
                            <label class="mr-1 small">Assign to:</label>
                            <select class="form-control custom-select form-control-sm">
                                <option value="">Unassigned</option>
                                <option value="u6">BARRATT, Ian (Mr)</option>
                                <option value="u4">BLACK, Steve (Mr)</option>
                                <option value="u1">BOWEN, Adam (Mr)</option>
                                <option value="u14">BOWEN, Adam Thomas (Mr) (away)</option>
                                <option value="u42663">BOWEN, AdamGPP</option>
                                <option value="u42347">BOWEN, AdamTestPass (Mr)</option>
                                <option value="u10">CAWTHORNE, Julia (Ms)</option>
                                <option value="u20">DODD, Tom (Mr)</option>
                                <option value="u5">FORD, Debbie (Ms)</option>
                                <option value="u3">LONGMAN, Harry (Mr)</option>
                                <option value="u17">SECONDARY-CAWTHORNE, Julia (Ms)</option>
                                <option value="u42877">TEST, test (Mr)</option>
                                <option value="u2">WALKER, AndyP (Mr)</option>
                                <option value="g161">Group: All Clinicians</option>
                                <option value="g2">Group: Doctors</option>
                                <option value="g3">Group: Practice Nurses</option>
                                <option value="g1">Group: Receptionists</option>
                                <option value="g154">Group: Test Group 2</option>
                                <option value="g155">Group: Test Group 3</option>
                                <option value="g156">Group: Test Group 4</option>
                                <option value="g172">Group: test new perm 2</option>
                            </select>
                        </div>

                        <button class="mb-1 ml-auto btn btn-primary btn-round align-self-end btn-sm">
                                <span class="icon icon-send"></span><span>Send / Assign</span>
                        </button>
                    </div>

                    <div style="position: relative; width: 100%;"><textarea type="textarea" id="new_message_textarea" class="new-message new-message-practice p-1 list-message-internal"></textarea> <input id="message-list-file-attach" type="file" class="hidden-file-input"> <label for="message-list-file-attach" class="p-2 position-absolute" style="top: 0px; right: 0px;"><span class="icon icon-attachment-inside"></span></label></div>
                        <div class="d-flex flex-wrap flex-row justify-content-between align-items-center" style="">
                            <b-navbar toggleable="lg" type="light" variant="light">
                                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                                      <b-collapse id="nav-collapse" is-nav class="d-flex">
                                          <b-button-group>
                                              <b-nav-item class="mb-1 btn btn-round btn-success mr-1 align-self-end btn-sm">Start QA</b-nav-item>
                                              <b-nav-item class="mb-1 btn btn-round btn-warning align-self-end btn-sm">Cancel</b-nav-item>
                                              <b-nav-item href="#" class="nav-item mb-1 btn btn-round btn-primary align-self-end btn-sm"><span class="icon" > </span>Await reply</b-nav-item>
                                              <b-dropdown class="nav-item nav-item mb-1 btn btn-round btn-primary align-self-end btn-sm" right text="Complete">
                                                  <div class="p-2">
                                                      <p>How was this request resolved?</p>
                                                      <b-dropdown-divider></b-dropdown-divider>
                                                      <b-dropdown-item v-on:click=''>Message</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Telephone call</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Face to face</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Video call</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Visit</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Abandoned</b-dropdown-item>
                                                  </div>
                                              </b-dropdown>
                                              <b-nav-item href="#" sm class="nav-item nav-item mb-1 btn btn-round btn-primary align-self-end btn-sm"><span class="icon icon-md icon-preset-message-white"></span>Preset message</b-nav-item>
                                              <b-dropdown class="nav-item nav-item mb-1 btn btn-round btn-primary align-self-end btn-sm" left text="Assign to">
                                                  <div class="p-2">
                                                      <b-dropdown-item v-on:click=''>Unassigned</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Name 1</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Name 2</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Name 3</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Name 4</b-dropdown-item>
                                                      <b-dropdown-item v-on:click=''>Name 5</b-dropdown-item>
                                                  </div>
                                              </b-dropdown>
                                              <b-nav-item href="#" sm class="nav-item mb-1 btn btn-round btn-success align-self-end btn-sm"><span class="icon icon-send"></span>Send/Assign</b-nav-item>
                                              <b-nav-item href="#" sm class="nav-item mb-1 btn btn-round btn-primary align-self-end btn-sm"><span class="icon" > </span>End wait</b-nav-item>
                                              <b-nav-item href="#" sm class="nav-item mb-1 btn btn-round btn-success align-self-end btn-sm"><span class="icon" > </span>Copy</b-nav-item>
                                              <b-nav-item href="#" sm class="nav-item mb-1 btn btn-round btn-warning align-self-end btn-sm"><span class="icon" > </span>Reopen</b-nav-item>
                                              <b-nav-item href="#" sm class="nav-item mb-1 btn btn-round btn-danger align-self-end btn-sm nav-item btn-sm"><span class="icon" > </span>Delete</b-nav-item>
                                              <b-nav-item href="#" sm class="nav-item mb-1 btn btn-round btn-primary align-self-end btn-sm nav-item btn-sm"><span class="icon" > </span>Set followup</b-nav-item>
                                          </b-button-group>
                                       </b-collapse>
                                   </b-navbar>
                               </div>
                           </div>
                       </div>
                   </div>

                   <div>
                     <b-nav pills>
                       <b-nav-item href="#1" active>Start QA</b-nav-item>
                       <b-nav-item href="#2" active>Cancel</b-nav-item>
                       <b-nav-item href="#3" active>Await Reply</b-nav-item>
                       <b-nav-item href="#4" active>Complete</b-nav-item>
                       <b-nav-item href="#2" active>Preset Message</b-nav-item>
                       <b-nav-item href="#2" active>Assign to</b-nav-item>
                       <b-nav-item href="#2" active>Send / Assign</b-nav-item>
                       <b-nav-item href="#2" active>End Wait</b-nav-item>
                       <b-nav-item href="#2" active success>Copy</b-nav-item>
                       <b-nav-item href="#2" active>Reopen</b-nav-item>
                       <b-nav-item href="#2">Delete</b-nav-item>
                       <b-nav-item href="#2" active>Set followup</b-nav-item>
                     </b-nav>
                   </div>

                    <div style="padding: 20px; width: auto">
                        <h3>DOB component test</h3>
                        // commented out!
                        <!-- <test-component v-model='test_dob' /> -->
                        <!-- <div class="form-group"> -->

                            <!-- <label for='dob'>Date of Birth</label>
                            <vue-dob-picker ref='dobPicker' show-labels='true' v-model='user_details.dob' /> -->
                            <!-- <input type='date' v-model='user_details.dob' class='form-control'> -->
                            <!-- <inline-error type='dob'></inline-error> -->
                        <!-- </div> -->
                    </div>
                    <div style="padding: 20px; width: 500px">
                        <h3>Password Strength Test - zxcvbn</h3>
                        <form>
                            <div class="form-group">
                        		<label for='name'>Name</label>
                                <input type="text" v-model="zxc.name" class='form-control'/>
                            </div>
                            <div class="form-group">
                        		<label for='name'>Email</label>
                                <input type="email" v-model="zxc.email" class='form-control'/>
                            </div>
                            <div class="form-group">
                        		<label for='name'>Password</label>
                                <input type="text" v-model="zxc.testpass"  class='form-control lab_password' autocomplete="off"/>
                            </div>
                            <button v-on:click.prevent="testZxcvbnmPassword" class="mb-3 btn btn-primary">Test</button><br />
                            <div class="form-group">
                                <label for='name'>Results</label>
                                <pre class='form-control'>{{zxc.results}}</pre>
                            </div>
                        </form>
                    </div>

                    <div style="padding: 20px; width: 500px">
                        <h3>Gruveo Video Test</h3>
                        <gruveo videocode='testabc123'></gruveo>
                    </div>


            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            zxc: {email: "", results: "none", name: ""},
            site_id: "",
            test_val: "",
            test_dob: null,
            user_details: {dob: null},
            start_datetime: "2012-03-04T05:06",
            signpost_data: [],
        };
    },
    watch: {
        site_id: function() {
            this.getData(true);
        },
        site_id(selectedSite) {
            localStorage.site_id = selectedSite;
        },
        test_val(testValue) {
            localStorage.test_val = testValue;
        },
    },
    mounted() {
        // if(localStorage.test_val) this.test_val = localStorage.test_val;
        // if(localStorage.site_id) this.site_id = localStorage.site_id;


    // Register event listener
        this.zxc = {email: this.$root.user.email, results: "none", name: this.$root.user.forenames + " " + this.$root.user.surname}
        this.signpost_data = this.signpost();
    },
    methods: {
        testZxcvbnmPassword() {
            axios.post("/api/v1/labs/zxcvbn", this.zxc).then((res) => {
                this.setLoading(false);
                console.log(JSON.stringify(res.data));
                //this.zxc.results = JSON.stringify(res.data.results, null, 2);
                this.zxc.results = JSON.stringify(res.data, null, 2);
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "check");
            });



        },
        signpost() {
            var data = {
                type: "form",
                data: "I think I might have covid",
            };

            axios.post("/api/v1/signpost", data).then((res) => {
                this.signpost_data = res.data;
            }).catch((error) => {
                this.handleError(error, "signpost");
            });
        }
    }
}
</script>


<style>
    .message-actions {
        .btn-success {
            background: transparent !important;
        }
    }
</style>
